module.exports = __webpack_public_path__ + "static/img/bg-01-sm_2025.3dec572.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-01-sm_2025.jpg
// module id = lUql
// module chunks = 98